//Angular
import { Component, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from "@angular/core";
import { Router } from "@angular/router";

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { ShoppingCartService } from "./../../../../services/inventory/shopping-cart.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { ClientAreaService } from "./../../../../services/settings/client-area.service"
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { BootboxService } from './../../../../services/core/bootbox.service';
import { ScriptService } from "./../../../../services/cms/script.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';

//Models
import { SeoViewModel } from "./../../../../models/core/seo";
import { CartInfo } from "./../../../../models/core/cart";
import { CartPaymentModel } from "./../../../../models/core/cart";
import { CartShipmentModel } from "./../../../../models/core/cart";
import { CartAddressModel } from "./../../../../models/core/cart";
import { Configuration } from "../../../../models/core/configuration";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';
import { ValidationService } from "../../../../services/core/validation.service";

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from "@angular/platform-browser";

@Component({
    template: ""
})

export class CartCashComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any,
            private scriptService: ScriptService
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        let cmsSub = this.cmsComponentService.getShoppingCartCashData().subscribe(result => {
             if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            
            if (this.isBrowser) {
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(result);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.cartCashId);

                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        });

        this.subManager.add(cmsSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(shoppingCartCashData: any) {
        @Component({
            template: shoppingCartCashData.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private router: Router,
                    private shoppingCartService: ShoppingCartService,
                    private languageService: LanguageService,
                    private authService: AuthService,
                    private clientAreaService: ClientAreaService,
                    private routeService: RoutesService,
                    private seoService: SeoService,
                    private bootboxService: BootboxService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    private breadcrumbsService: BreadcrumbsService,
                    private validationService: ValidationService
                ) { }

            currentAddress: CartAddressModel = new CartAddressModel();

            carrello: CartInfo = shoppingCartCashData.ShoppingCart;

            selectedAddress: CartAddressModel = new CartAddressModel();
            selectedPayment: CartPaymentModel = new CartPaymentModel();
            selectedShipment: CartShipmentModel = new CartShipmentModel();
            voucherCode: string = "";
            showValidationLabels: boolean = false;
            cartCashAccepted: boolean = false;

            OrderId: number;
            lang: string = this.languageService.getLongLang();

            isVoucherValid: boolean = false;
            isVoucherInvalid: boolean = false;
            isVoucherApplied: boolean = false;
            disableButtonCart: boolean = false;
            spinnerCartCash: boolean = false;
            $event: any;

            private pageIsOnDestroy: boolean = false;
            private seoInfo: SeoViewModel = shoppingCartCashData.SeoInformation;
            private pageIsInit: boolean = false;
            private carrelloPageName: string[] = [];
            private userId = this.authService.GetUserId();
            configuration: Configuration = shoppingCartCashData.ConfigurationInfo;
            private breadcrumbs: Breadcrumbs[] = shoppingCartCashData.BreadcrumbsInfo;

            subManager = new Subscription();

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                this.shoppingCartService.initCart(this.carrello);

                if (this.shoppingCartService.isCartValid() == false) {
                    this.router.navigate(this.routeService.getRoutePath('CARRELLO'));
                }
                else {
                    //Reading selected payment method
                    let payments = this.carrello.Payments;
                    let count = payments.length;

                    for (var i = 0; i < count; i++) {
                        let payment = payments[i];

                        if (payment.Selected == true) {
                            this.selectedPayment = payment;
                        }
                    }

                    //Reading selected shipment method
                    let shipments = this.carrello.Shipments;
                    count = shipments.length;

                    for (var i = 0; i < count; i++) {
                        let shipment = shipments[i];

                        if (shipment.Selected == true) {
                            this.selectedShipment = shipment;
                        }
                    }

                    //Reading selected address
                    let address = this.carrello.CurrentAddress;

                    let completeAddress = address.Address;

                    let lastIndex = completeAddress.lastIndexOf(" ");
                    let addressStreet: string = "";
                    let addressNumber: string = "";

                    if (lastIndex > -1) {
                        addressStreet = completeAddress.slice(0, lastIndex);
                        addressNumber = completeAddress.slice(lastIndex, completeAddress.length);
                    }

                    if (address != null) {
                        this.currentAddress.Id = address.Id;
                        this.currentAddress.Address = lastIndex > -1 ? addressStreet : address.Address;
                        this.currentAddress.City = address.City;
                        this.currentAddress.Recipient = address.Recipient;
                        this.currentAddress.Province = address.Province;
                        this.currentAddress.Phone = address.Phone;
                        this.currentAddress.ZipCode = address.ZipCode;
                        this.currentAddress.Mobile = address.Mobile;
                        this.currentAddress.CustomerID = this.userId;
                        this.currentAddress.Language = this.lang;
                        this.currentAddress.AddressNumber = lastIndex > -1 ? addressNumber : "";
                    }

                    this.carrelloPageName = this.routeService.getRoutePath('CARRELLO');
                }
            }

            //validation of phone numbers, disable writing any characters in input except of numbers
            validatePhone(event: any) {
                this.validationService.validatePhoneNumber(event);
            }


            //adding all scripts and elements connected to address verification feature                
            addAddressVerificationScripts(addressKey: string) {
                let suggest = "<script type=\"text/javascript\" id=\"suggestId\" src=\"/template/b2c/template01/layout/js/suggest.js\"></script>";
                let address = "<script id=\"addressVerificationId\" type=\"text/javascript\" title=" + addressKey + " src=\"/template/b2c/template01/layout/js/adress-verification.js?v=1\"></script>";
                let jquery = "<script type=\"text/javascript\" id=\"jqueryId\" src=\"/template/b2c/template01/layout/vendor/jquery/jquery.min.js\"></script>";

                $('body > universal-script').before(suggest);
                $('body > universal-script').before(jquery);
                $('body > universal-script').before(address);
            }

            //removing all scripts and elements connected to address verification feature                            
            removeAddressVerificationScripts(addressKey: string) {
                $("#suggestId").remove();
                $("#jqueryuicss").remove();
                $("#jqueryuijs").remove();
                $("#suggestcss").remove();
                $("#initui").remove();
                $("#inituicf").remove();
                $("#ui-id-1").remove();
                $("#ui-id-2").remove();
                $("div").remove(".ui-helper-hidden-accessible");

                $("#jqueryId").remove();
                $("#addressVerificationId").remove();
            }

            checkAddressValidation() {
                this.currentAddress.Province = $("#Prov").val();
                this.currentAddress.ZipCode = $("#Cap").val();
                this.currentAddress.City = $("#City").val();
            }

            setAddressValue() {
                let streetTypeId = $("#streetTypeId").val();
                let street = $("#Address").val();
                this.currentAddress.Address = street;

                if (streetTypeId != null && streetTypeId != "") {
                    if (!this.currentAddress.Address.startsWith(streetTypeId)) {
                        this.currentAddress.Address = streetTypeId + " " + street;
                    }
                }
                else {
                    this.currentAddress.Address = street;
                }
            }


            updateCartAddress() {
                //concating address street and number
                let model = this.currentAddress;
                let currentStreet = model.Address;
                model.Address = this.currentAddress.Address.trim() + " " + this.currentAddress.AddressNumber.trim();

                let cartSub = this.shoppingCartService.setAddress(model).subscribe(result => {
                    this.shoppingCartService.updateCart(result);
                    this.carrello = this.shoppingCartService.getCart();
                    if (result == false) {
                        this.bootboxService.i18nAlert("errorMex");
                    }
                },
                    err => {
                        this.bootboxService.i18nAlert("errorMex");
                    });

                this.subManager.add(cartSub);

                model.Address = currentStreet;
            }

            changeAddress(addressId) {
                //Reading selected address
                let addresses = this.carrello.Addresses;
                let count = addresses.length;

                var addressVal = $('#idSelectedAdress option:selected').text();

                for (var i = 0; i < count; i++) {
                    let address = addresses[i];

                    let completeAddress = address.Address;
                    let lastIndex = completeAddress.lastIndexOf(" ");
                    let addressStreet: string = "";
                    let addressNumber: string = "";

                    if (lastIndex > -1) {
                        addressStreet = completeAddress.slice(0, lastIndex);
                        addressNumber = completeAddress.slice(lastIndex, completeAddress.length);
                    }

                    if (address.Id == addressId && address.Recipient == addressVal) {
                        this.currentAddress.Id = address.Id;
                        this.currentAddress.Address = lastIndex > -1 ? addressStreet : address.Address;
                        this.currentAddress.City = address.City;
                        this.currentAddress.Recipient = address.Recipient;
                        this.currentAddress.Province = address.Province;
                        this.currentAddress.Phone = address.Phone;
                        this.currentAddress.ZipCode = address.ZipCode;
                        this.currentAddress.Mobile = address.Mobile;
                        this.currentAddress.CustomerID = this.userId;
                        this.currentAddress.Language = this.lang;
                        this.currentAddress.AddressNumber = lastIndex > -1 ? addressNumber : "";
                        break;
                    }
                }

                //concating address street and number to one property "Address"
                let model = this.currentAddress;
                model.Address = this.currentAddress.Address.trim() + " " + this.currentAddress.AddressNumber.trim();
                let currentStreet = model.Address;

                let shopCartSub = this.shoppingCartService.setAddress(model).subscribe(result => {
                    if (result == null || result == undefined) {
                        this.bootboxService.i18nAlert("errorMex");
                    }
                    else {
                        this.shoppingCartService.updateCart(result);
                        this.carrello = this.shoppingCartService.getCart();
                    }
                },
                    err => {
                        this.bootboxService.i18nAlert("errorMex");
                    });

                this.subManager.add(shopCartSub);

                //reverting address text to previous value after sending request                
                let lastIndex = currentStreet.lastIndexOf(" ");
                let addressStreet: string = currentStreet;

                if (lastIndex > -1) {
                    addressStreet = currentStreet.slice(0, lastIndex);
                }

                model.Address = addressStreet;
            };

            setJobName(rowId, jobName) {
                if (jobName != "") {
                    let jobNameSub = this.shoppingCartService.setJobName(rowId, jobName).subscribe(result => {
                        if (result == false) {
                            this.bootboxService.i18nAlert("errorMex");
                        }
                    },
                        err => {
                            this.bootboxService.i18nAlert("errorMex");
                        });

                    this.subManager.add(jobNameSub);
                }
            }

            applyVoucher(coupon) {
                if (this.voucherCode != null && this.voucherCode.trim().length > 0) {
                    let voucherSub = this.shoppingCartService.applyVoucher(this.voucherCode).subscribe(result => {
                        if (result.CartID != null) {
                            this.shoppingCartService.updateCart(result);
                            this.carrello = this.shoppingCartService.getCart();

                            this.isVoucherValid = true;
                            this.isVoucherInvalid = false;
                            this.isVoucherApplied = true;
                            this.voucherCode = "";
                        }
                        else {
                            this.isVoucherValid = false;
                            this.isVoucherInvalid = true;
                        }
                    },
                        err => {
                            this.bootboxService.i18nAlert("errorMex");
                        });

                    this.subManager.add(voucherSub);
                }
            };

            showModal() {
                this.disableButtonCart = false;
                this.spinnerCartCash = false;
                this.showValidationLabels = true;

                //JobNames
                let validProducts: boolean = true;
                let count = this.carrello.Products.length;
                for (var i = 0; i < count; i++) {
                    var product = this.carrello.Products[i];

                    //If one of the jobnames are not set then the validation fails
                    if (product.JobName != null && product.JobName.trim().length == 0) {
                        validProducts = false;
                        break;
                    }
                }

                let validAddress: boolean = true;

                if (validProducts == false || this.cartCashAccepted == false || !validAddress) {
                    return;
                }

                $("#cartCashModal").modal("show");
            }


            hideModal() {
                $('#cartCashModal').modal('hide');
                this.disableButtonCart = false;
            }

            confirmOrder() {
                this.disableButtonCart = true;
                this.spinnerCartCash = true;

                //Checking if all fields are valid
                let confirmOrderSub = this.shoppingCartService.confirmOrder().subscribe(result => {
                    if (result > 0) {
                        this.shoppingCartService.clearCartAfterConfirmation();

                        this.OrderId = result;
                        this.hideModal();

                        //Reading link of the page
                        var cartOrderDetailPageUrl = this.routeService.getRoutePath('CARRELLO ORDINE')[0];

                        //Removing system parameter (id)
                        cartOrderDetailPageUrl = cartOrderDetailPageUrl.replace(':id', '');

                        //Adding Order Id parameter
                        cartOrderDetailPageUrl += this.OrderId
                        this.spinnerCartCash = false;
                        this.router.navigate([cartOrderDetailPageUrl]);
                    }
                    else {
                        this.hideModal();
                        this.spinnerCartCash = false;
                        this.bootboxService.i18nAlert("errorMex");
                    }
                },
                    err => {
                        this.hideModal();
                        this.spinnerCartCash = false;
                        this.bootboxService.i18nAlert("errorMex");
                    });

                this.subManager.add(confirmOrderSub);
            };

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routeService.hidePageLoader();

                $('.popovers').popover();

                if (shoppingCartCashData.isActiveAddressVerificationModule) {
                    let addressVerificationKey = shoppingCartCashData.AddressVerificationCode;
                    if (addressVerificationKey != null && addressVerificationKey != undefined && addressVerificationKey != "") {
                        this.addAddressVerificationScripts(addressVerificationKey);
                        $("#Cap").prop('disabled', true);

                    }
                }
                else {
                    $("#Cap").prop('disabled', false);
                }

                this.pageIsInit = true;
            }

            ngOnDestroy() {
                if (!this.isBrowser || this.pageIsOnDestroy) {
                    return;
                }

                this.subManager.unsubscribe();

                //this method is removing all scripts and elements connected to address verification feature
                let addressVerificationKey = shoppingCartCashData.AddressVerificationCode;
                this.removeAddressVerificationScripts(addressVerificationKey);

                this.pageIsOnDestroy = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/inventory/shopping-cart/sys/cart-cash.component.ts